import lightness from 'lightness'

const color = '#202950'

document.body.style.setProperty('--primary-base', color)
document.body.style.setProperty('--primary-dark', lightness(color, -15))
document.body.style.setProperty('--primary-dark-5', lightness(color, -5))
document.body.style.setProperty('--primary-dark-10', lightness(color, -10))
document.body.style.setProperty('--primary-light', lightness(color, +15))
document.body.style.setProperty('--primary-light-10', lightness(color, +10))
document.body.style.setProperty('--primary-light-25', lightness(color, +25))



// WEBPACK FOOTER //
// ./src/helpers/colors.js